import * as THREE from 'three';

import * as mutationTypes from '../mutation-types';
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";

// state
const state = () => ({
  poser: {
    inst: null,
    position: new THREE.Vector3(0,0,0),
    rotation: new THREE.Vector3(0,0,0)
  },
  mannequins: [],
  mannequin: null,
  skinColors: [
    '#DDDDDD',
    '#D9AE9C',
    '#E5C4AF',
    '#BA876A',
    '#B97757',
    '#F1CBB2',
    '#E4C8BB',
    '#D7A389',
    '#6C392A',
    '#4B2723',
    '#362924',
    '#222222',
  ],
  loaders: {
    gltf: new GLTFLoader(),
  },
});

//getters
const getters = {
  poser: state => state.poser,
  mannequins: state => state.mannequins,
  mannequin: state => state.mannequin,
  mannequinByType: state => (type) => {
    return state.mannequins.filter(el => el.type === type)[0];
  },
  skinColors: state => state.skinColors,
  accessoriesOf: () => (model) => {
    const meshes = [];

    // console.log(model);
    function mapMesh(...array) {

      if(array.length) {
        array.map((child) => {

          if(child.type == 'Mesh') {

            if(child.material.name.includes('ACC_') || child.name.includes('ACC_'))
              meshes.push(child);

          } else {
            mapMesh(...child.children);
          }
        })
      }
    }

    if(model) {
      mapMesh(model);
    }    

    return meshes;
  },
  meshesOf: () => (model) => {
    const meshes = [];

    // console.log(model);
    function mapMesh(...array) {

      if(array.length) {
        array.map((child) => {

          if(child.type == 'Mesh') {

            meshes.push(child);

          } else {
            mapMesh(...child.children);
          }
        })
      }
    }

    if(model) {
      mapMesh(model);
    }    

    return meshes;
  },
};

const mutations = {
  [mutationTypes.UPLOAD_MANNEQUIN] (state,gltf) {

    // console.log(gltf.scene);

    // gltf.scene.scale.copy( new THREE.Vector3(100,100,100) );

    // if(gltf.scene.children.length === 0) {
    //   state.mannequin.inst = gltf.scene;
    // } else {
    //   state.mannequin.inst = gltf.scene.children[0];
    // }

    const groupMannequin = gltf.scene;
    state.mannequin.inst = groupMannequin;

    // todo rendere ricorsivo il metodo per ridurre gli errori
    // state.mannequin.inst.children[0].children[0].children.forEach(mesh => {
    //   // meshes.forEach(mesh => {
    //     console.log(mesh);
    //   if(mesh.material.map)
    //     mesh.material.map.encoding = THREE.LinearEncoding;

    //   mesh.material.roughness = THREE.MathUtils.clamp(mesh.material.roughness,0.75,1.00);
    // });

    // state.mannequin.inst.material.color = new THREE.Color(state.mannequin.color);
    // state.mannequin.inst.receiveShadow = true;
    // state.mannequin.inst.castShadow = true;
    // state.mannequin.inst.needsUpdate = true;
    // state.mannequin.inst.material.needsUpdate = true;

    state.poser.inst.add(groupMannequin);
  },
  [mutationTypes.SET_POSER_INSTANCE] (state,poser) {
    state.poser.inst = poser;
  },
  [mutationTypes.SET_MANNEQUIN_COLOR] (state,color) {
    state.mannequin.color = color;
    // state.mannequin.inst.material.color = new THREE.Color(color);
    // state.mannequin.inst.material.needsUpdate = true;
  },
  [mutationTypes.UPDATE_POSER_ROTATION] (state,{ lon }) {
    state.poser.inst.rotation.y = THREE.MathUtils.degToRad( -lon );
    state.poser.inst.needsUpdate = true;
  },
  [mutationTypes.INIT_MANNEQUINS] (state, mannequins) {
    state.mannequins = mannequins;
  },
  [mutationTypes.SET_MANNEQUIN] (state, mannequin) {
    // console.log('commit set mannequin')
    state.mannequin = mannequin;
  },
  [mutationTypes.REMOVE_MANNEQUIN] (state) {

    if(state.mannequin.inst) {
      // todo rifare il dispose dei modelli, non è più un oggetto unico
      // state.mannequin.inst.geometry.dispose(true);
      state.poser.inst.remove(state.mannequin.inst);
    }

    // state.mannequin.inst = null;
    // console.log({...state.mannequin},{...state.poser.inst});
  }
};

//actions
const actions = {
  uploadMannequin: ({ commit, state, dispatch, rootGetters },payload = true) => {
    state.loading = true;
    // console.log('upload mannequin');
    return new Promise((resolve, reject) => {

      try {

        // if(state.mannequin.inst) {
        //   commit(mutationTypes.UPLOAD_MANNEQUIN,state.mannequin.inst);
        //   return dispatch('uploadDefaultClothes');
        // } else {
        if(!state.mannequin.src) {
          dispatch('uploadDefaultClothes').then(() => {
            resolve();
          });
        } else {

          state.loaders.gltf.load(
            state.mannequin.src,
            (gltf) => {
              dispatch('setMapEncoding',gltf.scene);

              dispatch('shoes/setSelectedShoes',rootGetters['shoes/defaultShoes'],{root:true}).then(() => {

                commit(mutationTypes.UPLOAD_MANNEQUIN,gltf);

                if(payload) {
                  dispatch('uploadDefaultClothes').then(() => {
                    resolve();
                  });
                } else {
                  resolve();
                }

              });

              


            },
            xhr => xhr.loaded / xhr.total * 100,
            e => {
              state.loading = true;
              reject(`An error happened: ${e}`);
            });

        }

        // }

      } catch (e) {
        reject(`An error happened: ${e}`)
      }


    });
  },
  uploadDefaultClothes: ({ dispatch, rootGetters }) => {
    return new Promise( (resolve,reject) => {

      try {

        // let bottom = rootGetters['clothes/defaultBottomDress'];
        // let top = rootGetters['clothes/defaultTopDress'];
        let mise = rootGetters['clothes/defaultDress'];

        dispatch('clothes/wearDress',mise,{root:true}).then( () => {

          return dispatch('fabrics/applyFabric',{ payload: rootGetters['fabrics/defaultFabric'] },{root:true});

        }).then(() => {

          resolve();

        });

        //  codice per gestire separatamente il top e il bottom
        // dispatch('clothes/wearDress',bottom,{root:true}).then( () => {
        //
        //   // console.log('mann.js defaultFabric:',rootGetters['fabrics/defaultFabric']);
        //   return dispatch('fabrics/applyFabric',{ payload: rootGetters['fabrics/defaultFabric'] },{root:true});
        //
        // }).then(() => {
        //   return dispatch('clothes/wearDress',top,{root:true});
        // }).then( () => {
        //
        //   return dispatch('fabrics/applyFabric',{ payload: rootGetters['fabrics/defaultFabric'] },{root:true}).then(() => {
        //     // state.loading = false;
        //     resolve({
        //       top,
        //       bottom
        //     });
        //   })
        //
        // });

      } catch (e) {
        reject(`An error happened: ${e}`)
      }


    })
  },
  setPoserInstance ({ commit }, payload) {
    commit(mutationTypes.SET_POSER_INSTANCE,payload);
  },
  setMannequinColor: ({ commit },payload) => {
    return new Promise((resolve,reject) => {
      try {
        commit(mutationTypes.SET_MANNEQUIN_COLOR,payload);
        resolve(payload);
      } catch(e) {
        reject(`An error happened: ${e}`);
      }

    })

  },
  updatePoserRotation: ({ commit },payload) => {
    return new Promise((resolve,reject) => {
      try {
        commit(mutationTypes.UPDATE_POSER_ROTATION,payload);
        resolve(payload);
      } catch (e) {
        reject(`An error happened: ${e}`);
      }
    })
  },
  initMannequins: ({ commit, dispatch }, payload) => {
    return new Promise( (resolve,reject) => {


      try {

        commit(mutationTypes.INIT_MANNEQUINS,payload);
        //todo controlla se non è gia definito il tipo di manichino da caricare come default
        dispatch('setMannequin',{
          payload: payload[0],
          loadDefaultClothes: true,
        }).then( () => {
          resolve();
        });

      } catch (e) {
        reject(`An error happened: ${e}`);
      }


    });


  },
  setMannequin: ({ commit, dispatch, state }, { payload , loadDefaultClothes, force = false }) => {

    return new Promise((resolve,reject) => {

      if(!payload) {
        reject('You need a mannequin!');
      }

      if(state.mannequin && ( !(state.mannequin.type === payload.type) || force ) ) {
        
        try {

          // init mannequin shoes
          dispatch('shoes/initShoes',payload.shoes,{root:true});

          return dispatch('removeMannequin').then(() => {
            // console.log('before unwear all');
            return dispatch('clothes/unwearAll',null,{root:true});

          }).then(() => {
            // console.log('before set mannequin');
            commit(mutationTypes.SET_MANNEQUIN,payload);
            // console.log('before set clothes');
            return dispatch('clothes/setClothes',payload.clothes,{root:true});
          }).then(() => {
            // console.log('before upload mannequin');
            return dispatch('uploadMannequin',loadDefaultClothes);
          }).then(() => {
            dispatch('render',null,{root:true});
            resolve();
          });


        } catch (e) {
          reject(`An error happened: ${e}`);
        }

      } else {
        commit(mutationTypes.SET_MANNEQUIN,payload);
        // init mannequin shoes
        dispatch('shoes/initShoes',payload.shoes,{root:true});
        // console.log('after set mannequin');
        
        return dispatch('clothes/setClothes',payload.clothes,{ root:true }).then(() => {
          dispatch('uploadMannequin',loadDefaultClothes).then(() => {
            resolve();
          });
        });

      }

    });


  },
  removeMannequin: ({ commit,dispatch, getters }) => {
    return new Promise((resolve,reject) => {
      try {

        let groupMannequin = getters['mannequin'].inst;
        dispatch('dispose',groupMannequin);
        commit(mutationTypes.REMOVE_MANNEQUIN);

        // todo remove and dispose shoes
        dispatch('shoes/removeShoes',null,{root:true});



        //ripristino la selezione di texture e colore
        commit('textures/'+mutationTypes.SET_SELECTED_COLOR,'#ffffff',{root:true});
        commit('textures/'+mutationTypes.SET_SELECTED_TEXTURE,null,{root:true});

        resolve();
      } catch (e) {
        reject(`An error happened: ${e}`);
      }
    })
  },
  dispose: ({getters, dispatch},payload) => {

    // console.log('dispose mannequin');

    const meshes = getters['meshesOf'](payload);
    meshes.forEach(mesh => {
      // meshes.forEach(mesh => {
        // console.log(mesh);
        dispatch('fabrics/disposeMaterial',mesh.material,{root:true});
        mesh.geometry.dispose(true);
        mesh = null;
        // dispose mesh and mesh material
    });

  },
  setMapEncoding: ({getters},payload) => {

    const meshes = getters['meshesOf'](payload);

    // todo rendere ricorsivo il metodo per ridurre gli errori
    meshes.forEach(mesh => {
      // meshes.forEach(mesh => {
        // console.log(mesh);
      if(mesh.material.map)
        mesh.material.map.encoding = THREE.LinearEncoding;

      mesh.material.roughness = THREE.MathUtils.clamp(mesh.material.roughness,0.75,1.00);
    });


  }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}